import React from 'react'
import { Link } from 'react-router-dom'
import { Button, Col, Row } from 'reactstrap'

const InfluenzaResultsULC = () => {
  return (
    <div id='website-responsive'>
        <div className='left-padding6rem right-padding6rem pt-lg-4 pt-md-2 pt-4 pb-md-4 pb-4'>
            <Row className='py-md-3 reverse-section'>
                <Col md='' className=''>
                    <div className='flex-center'>
                        <img src='influenza-testing/Influenza-Testing-img2-v1.webp' alt='Results from United Lab Care' className='img-w8' />
                    </div>
                </Col>

                <Col md='' className=''>
                    <div className='pt-md-4'>
                        <div className=''>
                            <div className='fs-ss-30-2 text-montserrat text-ss-primary fw-700 lh-1-2 pb-2'>
                                Results from United Lab Care
                            </div>
                            <hr className='hr-style my-md-' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
                        </div>

                        <div className='pt-3'>
                            <div className='fs-ss-16 text-montserrat fw-600 text-ss-black lh-1-6' style={{ letterSpacing:'0.5px'}}>
                            In most cases, you will get the results of the flu test in Chicago right away. Without requiring a sample to be sent to a laboratory, many rapid tests provide results within 10 to 30 minutes. You might get the results the same day or in a few hours when you need a laboratory test.
                            </div>
                        </div>

                        <div className='pt-4'>
                            <div className='fs-ss-16 text-montserrat fw-600 text-ss-black lh-1-6' style={{ letterSpacing:'0.5px'}}>
                            A flu test will either show a positive or negative result. You can receive direct notification of the outcome or even a formal test report with the result in some cases.
                            </div>
                        </div>

                        <div className='pt-4 flex-center1 pb-md-0 pb-3'>
                        <Link to='/book-panel-test-appointment'>
                            <Button className='btn-ss-secondary rounded20 ' style={{  boxShadow:'1px 1px 6px 0 rgba(0,0,0,.4)'}}>
                                <text className='text-montserrat fw-600 fs-ss-16-1' style={{ padding:'',}}>
                                    SCHEDULE YOUR TEST
                                </text>
                            </Button>
                        </Link>
                        </div>
                    </div>
                </Col>
               
            </Row>
        </div>
    </div>
  )
}

export default InfluenzaResultsULC